<template>
  <LoadingScreen :state="loading"></LoadingScreen>
  <MainNav></MainNav>
  <router-view v-slot="{ Component, route }">
    <transition :name="transitionName" mode="out-in">
      <main :key="route.path">
        <component :is="Component" :key="route.path"></component>
      </main>
    </transition>
  </router-view>
</template>
<script>
import LoadingScreen from "@/components/PartsLoading.vue";
import MainNav from "@/components/PartsMainNavigation.vue";
export default {
  data() {
    return {
      loading: true,
    };
  },
  components: {
    MainNav,
    LoadingScreen,
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 200);
  },
  watch: {
    $route(to, from) {
      if (to.name.match("home")) {
        console.log("from pages to home");
        this.transitionName = "home";
      } else if (from.path == "/") {
        console.log("from home to pages");
        this.transitionName = "route";
      } else {
        this.transitionName = "route";
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// transition
.route-enter-from {
  opacity: 0;
  filter: blur(20px);
}
.route-enter-active,
.route-leave-active {
  transition: all 0.5s $easing;
}
.route-leave-to {
  opacity: 0;
  filter: blur(20px);
}
.home-enter-from {
  opacity: 0;
}
.home-enter-active,
.home-leave-active {
  transition: all 0.5s $easing;
}
.home-leave-to {
  opacity: 0;
}

//
.homearts_wrap {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.homearts-enter-from {
  opacity: 0;
  filter: blur(5px);
  &.homearts {
    transform: scale(1.5);
  }
}
.homearts-enter-active {
  transition: all 1.5s 1s $easing;
}
.homearts-leave-active {
  transition: all 1s $easing;
}
.homearts-leave-to {
  opacity: 0;
  filter: blur(20px);
  &.homearts {
    transform: scale(1.5);
  }
}
</style>
